import React from "react";
import "./Filter.scss";
import * as img from "../../assets/images/index";
import CheckBox from "components/CheckBox/CheckBox";

type Props = {
  checkList: any;
  setCheckList: any;
  onClick: any;
  onSubmit: any;
};

const Filter: React.FC<Props> = ({ checkList, onClick, onSubmit }) => {
  const [expand, setExpand] = React.useState(false);

  React.useEffect(() => {
    if (window.innerWidth > 750) {
      setExpand(true);
    }
  }, []);

  const filterList = [
    {
      name: "공지",
      key: "notice",
      value: "1",
    },
    {
      name: "긴급공지",
      key: "e_notice",
      value: "2",
    },
    {
      name: "업데이트",
      key: "update",
      value: "3",
    },
    {
      name: "이벤트",
      key: "event",
      value: "4",
    },
    {
      name: "기타",
      key: "etc",
      value: "5",
    },
  ];

  return (
    <div className="Filter">
      <p>구분</p>
      <button
        type="button"
        onClick={() => setExpand(!expand)}
        className={`expand-button ${expand ? "expand" : ""}`}
      >
        <img src={img.expandIcon} alt="펼침 아이콘" width="22" height="12" />
      </button>
      {expand && (
        <React.Fragment>
          <div className="Filter--content point">
            {filterList.slice(0, 3).map((item, index) => (
              <div style={{ display: "inline-block" }} key={item.key}>
                <CheckBox
                  checked={(checkList as any)[`${item.key}`]}
                  name={item.key}
                  onClick={onClick}
                />
                <span onClick={() => onClick(item.key)}>{item.name}</span>
              </div>
            ))}
          </div>
          <div className="Filter--content second">
            {filterList.slice(3, 5).map((item) => (
              <div style={{ display: "inline-block" }} key={item.key}>
                <CheckBox
                  checked={(checkList as any)[`${item.key}`]}
                  name={item.key}
                  onClick={onClick}
                />
                <span onClick={() => onClick(item.key)}>{item.name}</span>
              </div>
            ))}
          </div>
          <button
            type="button"
            className="agree-button"
            onClick={() => onSubmit()}
            disabled={
              Object.keys(checkList as any).filter((item) => {
                return checkList[item] === true;
              }).length === 0
            }
          >
            적용
          </button>
        </React.Fragment>
      )}
    </div>
  );
};

export default React.memo(Filter);
